import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { cx, noop } from 'ramda-extension';

import Hidden from '@gef-ui/components/atoms/SvgIcon/Icons/Hidden';
import Visible from '@gef-ui/components/atoms/SvgIcon/Icons/Visible';
import { getLabelMessage } from '@gef-ui/localization/messages';

const Card = ({ title, text, disabled = false, avatar, editButtonText, onToggle = noop, onEditClick = noop }) => {
	const handleEditClick = useCallback(() => {
		if (!disabled) {
			onEditClick();
		}
	}, [disabled, onEditClick]);

	const handleOnToggle = useCallback(() => {
		onToggle();
	}, [onToggle]);

	return (
		<div className={cx('CardMain', { 'CardMain--hidden': disabled })}>
			<div className="CardMain-header">
				<div className="CardMain-heading">{title}</div>
				{disabled ? (
					<Hidden className="CardMain-switch" onClick={handleOnToggle} />
				) : (
					<Visible className="CardMain-switch" onClick={handleOnToggle} />
				)}
			</div>
			<div className="CardMain-content">
				{avatar}
				{text && <div className="Avatar-text">{text}</div>}
				<div className="CardMain-link" onClick={handleEditClick}>
					{editButtonText || getLabelMessage('common:edit')}
				</div>
			</div>
		</div>
	);
};

Card.propTypes = {
	avatar: PropTypes.any,
	disabled: PropTypes.bool,
	editButtonText: PropTypes.string,
	onEditClick: PropTypes.func,
	onToggle: PropTypes.func,
	text: PropTypes.string,
	title: PropTypes.string,
};

export default Card;
